import React from "react";
import { Form, Row, Col, Button } from "antd";
import { useFieldArray } from "react-hook-form";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";
import ControlledTreeSelect from "../../components/Backoffice/ControlledTreeSelect";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledDatePicker from "../../components/Backoffice/ControlledDatePicker";
import ControlledRadio from "../../components/Backoffice/ControlledRadio";
import { addressToString } from "../../utils/formatter";

const PackageForm = ({
  errors,
  control,
  commodities,
  catalog,
  watch,
  setValue,
  getTestOptions,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "packages",
  });
  const handleSampleCount = (val, index) => {
    if (val > 100) {
      setValue(`packages.${index}.sampleCount`, 100);
    } else if (val >= 0) {
      setValue(`packages.${index}.sampleCount`, val);
    } else {
      setValue(`packages.${index}.sampleCount`, "");
    }
  };
  const handleAdd = () => {
    append({
      name: "",
      tests: [],
      notes: "",
      sampleCount: "",
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };

  return (
    <div>
      {fields.map((field, index) => (
        <div key={field.id}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <span style={{ marginRight: 0, fontWeight: "bold" }}>
              Package {index + 1}
            </span>

            {index > 0 ? (
              <Button onClick={() => handleRemove(index)} danger type="link">
                (Remove)
              </Button>
            ) : (
              ""
            )}
          </div>
          <Row gutter={24}>
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name={`packages.${index}.name`}
                label="Package Name"
                errors={errors}
              />
            </Col>
            <Col span={12}>
              <ControlledSelect
                required
                control={control}
                name={`packages.${index}.commodity`}
                label="Select Commodity"
                options={commodities}
                errors={errors}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <ControlledInput
                control={control}
                name={`packages.${index}.notes`}
                label="Notes"
                errors={errors}
              />
            </Col>
            <Col span={12}>
              <ControlledInput
                required
                type="number"
                control={control}
                name={`packages.${index}.sampleCount`}
                label="Sample Count"
                errors={errors}
                min={0}
                max={100}
                index={index}
                onChange={handleSampleCount}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <ControlledTreeSelect
                required
                control={control}
                name={`packages.${index}.tests`}
                label="Select Test Parameters"
                options={getTestOptions(index)}
                errors={errors}
              />
            </Col>
          </Row>
        </div>
      ))}
      <Button onClick={handleAdd} type="dashed" block>
        Add Package
      </Button>
    </div>
  );
};

const SinglePageOrderForm = ({
  control,
  options = {},
  watch,
  errors,
  isCompanyAdmin,
  setValue,
  getTestCategories,
}) => {
  const {
    companies = [],
    catalog = [],
    commodities = [],
    users = [],
    billingAddress = [],
    pickupAddress = [],
  } = options;

  const selectedCopmany = watch("company");
  const selectedUser = watch("user");
  const sampleCount = watch("packages.sampleCount");
  const currentDate = new Date();
  return (
    <Form colon={false}>
      <Row gutter={24}>
        {!isCompanyAdmin ? (
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="company"
              label="Select Company"
              options={companies}
              errors={errors}
            />
          </Col>
        ) : (
          ""
        )}

        {selectedCopmany ? (
          <Col span={isCompanyAdmin ? 24 : 12}>
            <ControlledSelect
              required
              control={control}
              name="user"
              label="Select User"
              options={users}
              errors={errors}
            />
          </Col>
        ) : (
          ""
        )}
      </Row>
      {selectedCopmany ? (
        <div>
          <PackageForm
            control={control}
            errors={errors}
            watch={watch}
            commodities={commodities}
            catalog={catalog}
            sampleCount={sampleCount}
            setValue={setValue}
            getTestOptions={getTestCategories}
          />
          <Row style={{ marginTop: 30 }}>
            <Col span={24}>
              <ControlledDatePicker
                required
                control={control}
                name="pickupRequestDate"
                label="Schedule Pickup Date"
                errors={errors}
                minimum={new Date(currentDate.getTime() + 86400000)}
              />
            </Col>
          </Row>
          {selectedUser ? (
            <>
              <Row>
                <Col span={24}>
                  <ControlledRadio
                    required
                    control={control}
                    name="billingAddress"
                    options={billingAddress.map((addr) => ({
                      value: addr._id,
                      label: addressToString(addr),
                    }))}
                    label="Billing Address"
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <ControlledRadio
                    required
                    control={control}
                    name="pickupAddress"
                    options={pickupAddress.map((addr) => ({
                      value: addr._id,
                      label: addressToString(addr),
                    }))}
                    label="Pickup Address"
                    errors={errors}
                  />
                </Col>
              </Row>
            </>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </Form>
  );
};

export default SinglePageOrderForm;
